export default __webpack_public_path__ + "static/media/orientation_video_ALL.b937a565.png";